import React from "react";

class StopButton extends React.Component {
  stop() {
    this.props.counter.stop();
  }

  render() {
    return <button onClick={this.stop.bind(this)}>Stop</button>;
  }
}

export { StopButton };
